import React from 'react';
import { Container, Row, Col, Table } from 'react-bootstrap';
import { motion } from 'framer-motion';

declare global {
  interface Window { fbq?: (...args: any[]) => void }
}

const track = (event: string, params?: Record<string, any>) => {
  if (typeof window !== 'undefined' && typeof window.fbq === 'function') {
    window.fbq('trackCustom', event, params || {});
  }
};

const WHATSAPP_URL = 'https://api.whatsapp.com/message/5LUL6QCX55ICO1?autoload=1&app_absent=0';

const ListaPrecios = () => {
  return (
    <Container fluid="xxl" className="py-5">
      <Row className="justify-content-center">
        <Col xs={12} md={11} lg={10} className="text-center mb-1">
          <h2 className="display-4 brand-font">¡Armá tu box como más te guste, y ya estás listo para disfrutar tu pedido!</h2>
        </Col>
      </Row>

      <Row className="justify-content-center mt-5">
        <Col xs={12} md={11} lg={10}>
          <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.4 }} className="mb-5">
            <div className="text-center mb-4">
              <h2 className="h2 brand-font mb-2">📝 Tips para hacer tu compra:</h2>
            </div>
            <div className="mx-auto p-4 rounded shadow-sm" style={{ backgroundColor: '#1e1e1e', color: '#f1f1f1', maxWidth: '600px' }}>
              <Table borderless responsive className="mb-0">
                <tbody>
                  <tr><td>🧃 <strong>Compra mínima:</strong> 1 Box📦 (6 unidades c/u)</td></tr>
                  <tr><td>📦 <strong>¿Cómo armarlo?:</strong> Cada producto tiene un mínimo de compra, ¡Elegí tus favoritos hasta llegar a 6!</td></tr>
                  <tr><td>🚚 <strong>Envíos:</strong> a todo el país — CABA y GBA, consultar costo segun zona</td></tr>
                  <tr><td>⏱️ <strong>Entrega:</strong> 72hs en lo posible desde la confirmación</td></tr>
                  <tr><td>🛒 <strong>Compras:</strong> solo online</td></tr>
                  <tr><td>💸 <strong>Pagos:</strong> únicamente por transferencia o depósito</td></tr>
                  <tr className="purchase-tips-spacer" aria-hidden="true"><td /></tr>
                  <tr><td>💼 Si sos <strong className="h5">Mayorista o tenés una Vinoteca</strong>, y tu compra <strong>supera los $700.000</strong>, ¡Consultanos directamente para brindarte <strong>tarifas personalizadas!</strong></td></tr>
                </tbody>
              </Table>
            </div>

            <div className="separator mb-4" />

            <motion.section
              className="store-announcement"
              initial={{ opacity: 0, y: 24 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.15, duration: 0.55 }}
              aria-labelledby="store-announcement-title"
            >
              <span className="store-announcement__eyebrow">Una nueva experiencia está por llegar</span>
              <h1 id="store-announcement-title" className="store-announcement__title brand-font">
                Tu club de vinos favorito y tu tienda online favorita, en un solo lugar.
              </h1>
              <p className="store-announcement__copy">
                Muy pronto vas a poder elegir tus vinos y hacer tus pedidos directamente desde nuestro e-commerce.
              </p>
              <p className="store-announcement__note">
                Mientras tanto, pedinos nuestra lista de precios por WhatsApp y te ayudamos a armar tu box.
              </p>
              <motion.a
                href={WHATSAPP_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="whatsapp-button store-announcement__cta"
                onClick={() => track('CTA_WhatsApp_Click', { position: 'store_announcement' })}
                whileHover={{ scale: 1.04 }}
                whileTap={{ scale: 0.97 }}
              >
                <i className="fab fa-whatsapp" aria-hidden="true" />
                Pedí nuestra lista de precios
              </motion.a>
            </motion.section>
          </motion.div>
        </Col>
      </Row>
    </Container>
  );
};

export default ListaPrecios;
